import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import Pricing from "@/components/Pricing";
import NextPageCta from "@/components/NextPageCta";

export default function PricingPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Pricing"
        title="Honest pricing."
        italic="Quoted per job."
        blurb="Two signature packages, three à-la-carte services. Every final quote is fixed in writing within 24 hours of your request — no hidden extras."
      />
      <Pricing />
      <NextPageCta to="/faq" label="Got questions? →" sub="Pricing, insurance, deposit guarantees and more — straight answers in the FAQ." />
    </Layout>
  );
}
